import styled from "styled-components";

export const InvokeLockoutModalWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 10px 0px;
`;

export const InvokeLockoutDeviceName = styled.div`
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    width: 100%;
`;

export const InvokeLockoutTips = styled.div`
    font-size: 12px;
    text-align: center;
    margin: 10px 0px;
    color: #555555;
`;

export const InvokeLockoutParams = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const InvokeLockoutParam = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const InvokeLockoutParamLabel = styled.div`
    font-size: 12px;
    padding: 5px 5px;
    color: #555555;
`;

export const InvokeLockoutParamInput = styled.div`
    width: 100%;
`;

export const InvokeLockoutResponse = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 20px;
`;

export const InvokeLockoutResponseTitle = styled.div`
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 5px;
`;

export const InvokeLockoutResponseParams = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
`;

export const InvokeLockoutResponseParam = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin: 10px 0px;
    width: 100%;
`;

export const InvokeLockoutResponseParamLabel = styled.div`
    font-size: 12px;
    padding: 5px 5px;
    color: #555555;
`;

export const InvokeLockoutResponseParamValue = styled.div`
    width: 100%;
    padding: 5px;
    background-color: #F0F0F0;
    border-radius: 5px;
    box-sizing: border-box;
`;

export const InvokeLockoutResponseRaw = styled.div`
    display: flex;
`;